/**
 * SuiteCRM is a customer relationship management program developed by SalesAgility Ltd.
 * Copyright (C) 2021 SalesAgility Ltd.
 *
 * This program is free software; you can redistribute it and/or modify it under
 * the terms of the GNU Affero General Public License version 3 as published by the
 * Free Software Foundation with the addition of the following permission added
 * to Section 15 as permitted in Section 7(a): FOR ANY PART OF THE COVERED WORK
 * IN WHICH THE COPYRIGHT IS OWNED BY SALESAGILITY, SALESAGILITY DISCLAIMS THE
 * WARRANTY OF NON INFRINGEMENT OF THIRD PARTY RIGHTS.
 *
 * This program is distributed in the hope that it will be useful, but WITHOUT
 * ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS
 * FOR A PARTICULAR PURPOSE. See the GNU Affero General Public License for more
 * details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 *
 * In accordance with Section 7(b) of the GNU Affero General Public License
 * version 3, these Appropriate Legal Notices must retain the display of the
 * "Supercharged by SuiteCRM" logo. If the display of the logos is not reasonably
 * feasible for technical reasons, the Appropriate Legal Notices must display
 * the words "Supercharged by SuiteCRM".
 */

import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ScrollingModule} from '@angular/cdk/scrolling';
import {HistorySidebarWidgetComponent} from './history-sidebar-widget.component';
import {FieldModule} from '../../../../fields/field.module';
import {WidgetPanelModule} from '../../../../components/widget-panel/widget-panel.module';
import {ImageModule} from '../../../../components/image/image.module';
import {LoadingSpinnerModule} from '../../../../components/loading-spinner/loading-spinner.module';
import {LabelModule} from '../../../../components/label/label.module';
import {ChartMessageAreaModule} from '../../../../components/chart/components/chart-message-area/chart-message-area.module';
import {RouterModule} from "@angular/router";
import {ButtonModule} from "../../../../components/button/button.module";
import {
    HistorySidebarSkeletonLoadingComponent
} from "./history-sidebar-skeleton-loading/history-sidebar-skeleton-loading.component";

@NgModule({
    declarations: [HistorySidebarWidgetComponent],
    exports: [
        HistorySidebarWidgetComponent
    ],
    imports: [
        CommonModule,
        ScrollingModule,
        ImageModule,
        FieldModule,
        WidgetPanelModule,
        LoadingSpinnerModule,
        LabelModule,
        ChartMessageAreaModule,
        RouterModule,
        ButtonModule,
        HistorySidebarSkeletonLoadingComponent,
    ]
})
export class HistorySidebarWidgetModule {
}
